import { addDays, getISOWeek, parseISO, startOfISOWeek, format } from 'date-fns';
import { daysBetween, fmtShort, pctChange } from '../k2/k2utils';

const iso = (d) => format(d, 'yyyy-MM-dd');
const WD = ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'];
export const inRange = (d, from, to) => d && d >= from && d <= to;

export function sumDocs(docs, from, to) {
  const r = docs.filter((x) => inRange(x.date, from, to));
  const amount = r.reduce((a, x) => a + x.amount, 0);
  return { amount, count: r.length, partners: new Set(r.map((x) => x.partner)).size, avg: r.length ? amount / r.length : 0, rows: r };
}

export function dayRows(docs, from, to) {
  return daysBetween(from, to).map((d) => {
    const s = sumDocs(docs, d, d);
    return { key: d, label: `${WD[parseISO(d).getDay()]} ${fmtShort(d)}`, amount: s.amount, count: s.count };
  });
}

export function weekRows(docs, from, to) {
  const out = [];
  for (let start = startOfISOWeek(parseISO(from)); iso(start) <= to; start = addDays(start, 7)) {
    const wFrom = iso(start) < from ? from : iso(start);
    const wEnd = iso(addDays(start, 6));
    const wTo = wEnd > to ? to : wEnd;
    const s = sumDocs(docs, wFrom, wTo);
    out.push({ key: wFrom, label: `T${getISOWeek(start)} (${fmtShort(wFrom)}–${fmtShort(wTo)})`, amount: s.amount, count: s.count });
  }
  return out.map((w, i) => ({ ...w, delta: i > 0 ? pctChange(w.amount, out[i - 1].amount) : null }));
}

export function rankPartners(docs, range, withPrev) {
  const map = new Map();
  docs.forEach((x) => {
    const cur = inRange(x.date, range.from, range.to);
    const prev = withPrev && inRange(x.date, range.prevFrom, range.prevTo);
    if (!cur && !prev) return;
    if (!map.has(x.partner)) map.set(x.partner, { name: x.partner, amount: 0, count: 0, prev: 0 });
    const p = map.get(x.partner);
    if (cur) { p.amount += x.amount; p.count += 1; } else p.prev += x.amount;
  });
  const total = [...map.values()].reduce((a, p) => a + p.amount, 0);
  return [...map.values()].filter((p) => p.count > 0)
    .map((p) => ({ ...p, share: total ? (p.amount / total) * 100 : 0, delta: pctChange(p.amount, p.prev) }))
    .sort((a, b) => b.amount - a.amount).map((p, i) => ({ ...p, rank: i + 1 }));
}

export function rankArticles(items, range, withPrev) {
  const map = new Map();
  items.forEach((x) => {
    const cur = inRange(x.date, range.from, range.to);
    const prev = withPrev && inRange(x.date, range.prevFrom, range.prevTo);
    if (!cur && !prev) return;
    const k = x.article_code || x.article_name;
    if (!map.has(k)) map.set(k, { code: x.article_code, name: x.article_name, unit: x.unit, qty: 0, value: 0, prevQty: 0, prevValue: 0, lines: [], docs: new Set(), min: null, max: null });
    const a = map.get(k);
    if (!cur) { a.prevQty += x.quantity; a.prevValue += x.value; return; }
    a.qty += x.quantity; a.value += x.value; a.lines.push(x); a.docs.add(x.doc_rid);
    if (x.quantity) {
      const up = x.value / x.quantity;
      a.min = a.min == null ? up : Math.min(a.min, up);
      a.max = a.max == null ? up : Math.max(a.max, up);
    }
  });
  return [...map.values()].filter((a) => a.lines.length).map((a) => {
    const avg = a.qty ? a.value / a.qty : null;
    const prevAvg = a.prevQty ? a.prevValue / a.prevQty : null;
    return { ...a, avg, prevAvg, priceDelta: avg != null && prevAvg ? pctChange(avg, prevAvg) : null, docCount: a.docs.size };
  });
}
